import type {
  RallyPoint,
  RallyEvent,
  RallyClaimResponse,
  RallyVerify,
} from "@greg-chick/shared";
import { EDGE_BASE } from "../lib/apiBase";

export interface RallyStatus {
  points: RallyPoint[];
  event: RallyEvent; // 선착순 인원(winners)·기간 — 관리자 설정 반영
  claimed: string[];
  collected: number;
  total: number;
  completed: boolean;
  rank?: number;
  claimCode?: string;
  withinWinners?: boolean;
  claimFormUrl?: string;
  completions?: number; // 전체 완주자 수(집계 — "지금까지 N명 완주" 표시)
}

export interface ClaimInput {
  hero: string;
  pointId: string;
  method: RallyVerify;
  coord?: { lat: number; lng: number; accuracy: number };
  qrToken?: string | null;
}

/** 랠리 상태 조회. 서버(엣지) 미가동/오류 시 null. */
export async function getRally(hero: string): Promise<RallyStatus | null> {
  try {
    const res = await fetch(`${EDGE_BASE}/api/rally?hero=${encodeURIComponent(hero)}`);
    if (!res.ok) return null;
    return (await res.json()) as RallyStatus;
  } catch {
    return null;
  }
}

export async function claimStamp(
  input: ClaimInput,
): Promise<RallyClaimResponse | null> {
  try {
    const res = await fetch(`${EDGE_BASE}/api/rally/claim`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(input),
    });
    return (await res.json()) as RallyClaimResponse;
  } catch {
    return null;
  }
}

/** 위치 1회 취득(고정밀). 인증 순간 단일 좌표만 — 저장·전송 최소(FR-RALLY-08). */
export function getPositionOnce(): Promise<{
  lat: number;
  lng: number;
  accuracy: number;
}> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("no_geolocation"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) =>
        resolve({
          lat: p.coords.latitude,
          lng: p.coords.longitude,
          accuracy: p.coords.accuracy,
        }),
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 },
    );
  });
}

/** 카카오맵 길찾기 외부 링크(FR-RALLY-01). */
export function kakaoRouteUrl(p: RallyPoint): string {
  return `https://map.kakao.com/link/to/${encodeURIComponent(p.title_ko)},${p.lat},${p.lng}`;
}
